(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaLastUpdateDate', RcopiaLastUpdateDate);

    RcopiaLastUpdateDate.$inject = ['$resource'];

    function RcopiaLastUpdateDate ($resource) {
        var resourceUrl =  'api/rcopia-last-update-dates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-last-update-dates/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
        });
    }
})();
